@if (selectedChannel()?.enabled) {
<ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canUseAutoResponses]">
  <div class="standard-responses">
    @if (!selectedChannel()!.isLoadingStandardResponses) { @if (selectedChannel()?.standardResponses?.length) {
    <div class="standard-responses__title">
      {{ 'NGX-MESSAGING.CHAT.standardResponses' | translate }}
    </div>
    }
    <div class="standard-responses__chips">
      @for (response of selectedChannel()!.standardResponses; track response.message) {
      <div
        class="standard-responses__chips__button chip"
        [matTooltip]="response.message"
        (click)="selectAutoResponse(response.message)">
        {{ response.message | longText }}
      </div>
      }
    </div>
    } @else {
    <div class="standard-responses__title">{{ 'NGX-MESSAGING.CHAT.loadingStandardResponses' | translate }}...</div>
    }
  </div>
</ng-container>
}
